<h2 mat-dialog-title class="flex items-center gap-2">
  <mat-icon *ngIf="data.icon" class="text-primary">{{ data.icon }}</mat-icon>
  {{ data.title }}
</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">
    {{ 'COMMON.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="confirm()" class="ml-2">
    <mat-icon *ngIf="data.icon">{{ data.icon }}</mat-icon>
    {{ data.confirmLabel }}
  </button>
</mat-dialog-actions>
